import BootstrapField from '../utility/BootstrapField';
import IsEqual from 'lodash.isequal';
// import CloneDeep from 'lodash.clonedeep';
import RestrictionBlock from './RestrictionBlock';
import Attachment from '../models/Attachment';

// As private as it gets.
let originalRestrictionData = null;

export default class Restriction {

	constructor(data) {
		if (!data) {
			data = {};
		}
		Object.assign(this, {
			id: data.id || null,
			lcrId: data.lcrId || null,
			ownerId: data.id || null,
			reporterId: data.reporterId || null,
			createdDate: data.createdDate || null,
			createdUserId: data.createdUserId || null,
			fromDateTime: new BootstrapField({
				value: data.fromDateTime || null,
				required: true,
				type: BootstrapField.Types.date,
				invalidMessage: 'Please enter a valid reporting date',
			}),
			toDateTime: new BootstrapField({
				value: data.toDateTime || null,
				type: BootstrapField.Types.date,
				validator: function(value) {
					return value instanceof Date;
				},
				invalidMessage: 'Please enter a valid estimated completion date',
			}),
			inEffect: new BootstrapField({
				value: typeof data.inEffect === 'number' ? data.inEffect : null
			}),
			trafficEffect: new BootstrapField({
				value: data.trafficEffect || null
			}),
			block: [],
			attachment: [],
		});

		if (data.block instanceof Array) {
			let x = 0;
			for (x = 0; x < data.block.length; x++) {
				this.block.push(new RestrictionBlock(data.block[x]));
			}
		}
		if (data.attachment instanceof Array) {
			let x = 0;
			for (x = 0; x < data.attachment.length; x++) {
				this.attachment.push(new Attachment(data.attachment[x]));
			}
		}

		// Keep a record of the old data. (used for the hasChanges() method)
		originalRestrictionData = this.getRawValue();

	}

	validate() {
		this.fromDateTime.invalidMessage = 'Please enter a valid end time';
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}

		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}
	hasChanges() {
		return !IsEqual(originalRestrictionData, this.getRawValue());
	}
	revertChanges() {
		this.constructor(originalRestrictionData);
	}
	saveChanges() {
		// originalRestrictionData = CloneDeep(this);
		originalRestrictionData = this.getRawValue();
	}
}